export const safariScrollFix = (iframe: HTMLIFrameElement): void => {
  iframe.contentDocument!.body.style.display = 'none';
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  iframe.contentDocument!.body.offsetHeight;
  iframe.contentDocument!.body.style.display = 'block';
};
